export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/40 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-20 right-0 w-[500px] h-[500px] rounded-full bg-primary-100/20 blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-[350px] h-[350px] rounded-full bg-accent-100/20 blur-3xl"></div>

      <div className="relative w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-24 lg:pt-0">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-6">
              <i className="ri-fire-fill text-sm"></i>
              多平台视频资源聚合
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 font-heading leading-tight mb-4">
              青青草视频<span className="text-primary-500"> · </span>多平台视频资源聚合导航
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-heading mb-6">
              久久视频 · 芒果视频 · 97视频 · 丝瓜视频 — 一站直达，畅享高清
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              青青草视频致力于为用户打造便捷的在线视频资源导航体验。我们汇聚久久视频、芒果视频、97视频、丝瓜视频、蓝莓视频、91在线视频、糖心视频、黑桃视频等主流平台入口，提供流畅在线播放与高清视频网站体验。无论您偏好哪种类型的视频内容，都能在这里快速找到对应平台，无需反复搜索。当前已覆盖多个热门视频平台，每日保持内容入口更新，确保您不错过任何精彩。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-links-line text-accent-600 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">8+</div>
                  <div className="text-xs text-foreground-500">聚合平台</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-refresh-line text-primary-600 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">每日更新</div>
                  <div className="text-xs text-foreground-500">内容入口</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-600 text-sm"></i>
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">安全导航</div>
                  <div className="text-xs text-foreground-500">绿色上网</div>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-fire-fill"></i>
                查看热门榜单
              </a>
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-background-300 text-foreground-700 font-medium text-sm hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-compass-3-line"></i>
                探索话题广场
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end pb-10 lg:pb-0">
            <div className="relative w-[280px] h-[380px] md:w-[360px] md:h-[480px] rounded-2xl overflow-hidden bg-background-100 border border-background-200/70">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20and%20dynamic%20digital%20media%20collage%20with%20floating%20video%20play%20buttons%2C%20colorful%20gradient%20film%20strips%2C%20streaming%20interface%20elements%2C%20abstract%20geometric%20shapes%20in%20warm%20orange%20and%20coral%20tones%2C%20modern%20entertainment%20technology%20theme%2C%20clean%20minimalist%20background%20with%20soft%20lighting%2C%20professional%20and%20energetic%20atmosphere&width=720&height=960&seq=hero-visual-2026&orientation=portrait"
                alt="青青草视频 - 多平台视频资源聚合导航"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="flex-1 bg-white/90 backdrop-blur-sm rounded-xl px-4 py-3">
                  <div className="flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
                      <i className="ri-play-fill text-background-50 text-sm"></i>
                    </div>
                    <div className="min-w-0">
                      <div className="text-xs font-medium text-foreground-900 truncate">青青草视频导航</div>
                      <div className="text-xs text-foreground-500">多平台 · 高清 · 不缓冲</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}